export default __webpack_public_path__ + "static/media/help.74df944c.svg";